import {
  Grid,
  GridItem,
  Tab,
  TabList,
  Tabs,
  Text,
  VStack,
} from '@cdl/heartbeat-react';
import { FiltersBar } from './dashboard/filters/FiltersBar';
import { useEffect } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { loadAnnotationGridsList } from '../thunks/load-annotation-grids-list.thunks';
import { loadAnnotatorsList } from '../thunks/load-annotators-list.thunks';
import { useDispatch } from 'react-redux';
import { useUpdateURLSearchParams } from '../hooks/useUpdateURLSearchParams';

export const Dashboard = () => {
  const dispatch = useDispatch();

  useUpdateURLSearchParams();

  useEffect(() => {
    dispatch(loadAnnotatorsList(true));
    dispatch(loadAnnotationGridsList());
  }, [dispatch]);

  return (
    <VStack alignItems='stretch' spacing='xl' w='full'>
      <Grid templateColumns='repeat(2, 1fr)'>
        <GridItem>
          <Text textStyle='page-title'>Task management</Text>
          <Text textStyle='page-subtitle'>All annotation tasks</Text>
        </GridItem>
        <GridItem>
          <FiltersBar />
        </GridItem>
      </Grid>
      <Tabs orientation='horizontal' variant='line'>
        <TabList mb='s' border='0'>
          <Link to={'/admin/dashboard/active'}>
            <Tab>Active</Tab>
          </Link>
          <Link to={'/admin/dashboard/inactive'}>
            <Tab>Inactive</Tab>
          </Link>
        </TabList>
        <Outlet />
      </Tabs>
    </VStack>
  );
};
